import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const Account = shopApp.dynamic(() => import("./Account"));
	const url = "/account";

	let config = {
		name: "Account",
		routes: [
			<Route key={url} exact path={url} component={Account}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
